import Modal from "react-bootstrap/esm/Modal";
import { CourseEvent } from "../../../models/CourseEvent"
import { FC, useState } from 'react';
import Form from "react-bootstrap/esm/Form";
import Button from "react-bootstrap/esm/Button";
import UserRegistrationEndpoint from "../../../../api/endpoint/UserRegistrationEndpoint";


interface ManualRegistrationProps {
    courseEvent: CourseEvent;
    show: boolean;
    onHide: () => void;
    initiateReload: () => void;
}

export const ManualRegistration: FC<ManualRegistrationProps> = ({courseEvent, show, onHide, initiateReload}) => {
    const [validated, setValidated] = useState(false);
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else if(form.checkValidity() === true) {
            event.preventDefault();
            handleRegister();
            initiateReload();
            onHide();
        }

        setValidated(true);
    };

    const handleRegister = async() => {
        const userRegistration = {
            course_event_id: courseEvent.course_event_id,
            full_name: fullName,
            email: email,
            phone_number: phone,
            attended_class_1: false,
            attended_class_2: false,
            survey_completed: false
        };

        const registerResult = await UserRegistrationEndpoint.Register(userRegistration);

        if(!registerResult || registerResult.errors.length > 0 || !registerResult.data){
            console.error('Error creating course');
        }
    };

    
    return (
        <Modal
            show={show}
            centered
            onHide={onHide}
            aria-labelledby="manual-registration-title"
        >
            <Modal.Header>
                <Modal.Title id="manual-registration-title">Manual Registration for {courseEvent.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="register-name">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control type="text" required onChange={(e: any) => setFullName(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter a full name.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="register-email">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" required onChange={(e: any) => setEmail(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter an email.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="register-phone">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control type="tel" required onChange={(e: any) => setPhone(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter a phone number.</Form.Control.Feedback>
                    </Form.Group>
                    
                    <Modal.Footer>
                        <Button variant="secondary" onClick={onHide}>Close</Button>
                        <Button variant="primary" className="text-light" type="submit">Submit</Button>
                    </Modal.Footer>
                    
                </Form>
            </Modal.Body>
        </Modal>
    )
}